import LayoutBasic from '@/components/LayoutBasic/LayoutBasic.vue'
import { JSConn } from '@/utilities/js-conn.js'
import { TOAST_DURATION } from '@/constants'

export default {
  name: 'SeedEditForm',
  components: {
    LayoutBasic
  },
  props: ['id'],
  data () {
    return {
      seedEditItem: null,
      mode: 'edit'
    }
  },
  created () {
    if (this.id === 'new') {
      this.mode = 'new'
      this.seedEditItem = {
        description: null,
        costPerUnit: null,
        seedsPerUnit: null,
        defaultSeedingRate: null
      }
    } else {
      this.mode = 'edit'
      const item = this.$store.getters.getSeedItemById(this.id)
      // just want a local copy for the form
      this.seedEditItem = {...item}
    }
  },
  methods: {
    submitForm (evt) {
      evt.preventDefault()
      const jsConn = new JSConn()
      jsConn.toRoutePath = '/seeds'

      jsConn.formParams = {
        id: this.id,
        item: this.seedEditItem
      }

      this.$store.dispatch('updateSeedItem', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
          this.$router.push(jsConn.toRoutePath)
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    }
  }
}
